// extracted by mini-css-extract-plugin
export default {"Page":"index_Page__85xYD","TabBar":"index_TabBar__HfOwY","Tabs":"index_Tabs__xnGTf","List":"index_List__fcJGg"};